<template>
  <div id="layoutAuthentication">
    <div id="layoutAuthentication_content">
      <main>
        <div class="container mt-0">

          <div class="row">
            <div class="col">
              <ul class="nav nav-pills justify-content-center">
                <li class="nav-item">
                  <a class="nav-link" :class="{active: isSelected === 'crew' }" href="#" @click="isActiveTab('crew')">
                    <font-awesome-icon icon="user-shield" />
                    Crew</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" :class="{active: isSelected === 'staff' }" href="#" @click="isActiveTab('staff')">
                    <font-awesome-icon icon="user" />
                    Staff</a>
                </li>
              </ul>
            </div>

          </div>

          <div class="row justify-content-center">
            <div class="col-lg-5">
              <div class="card shadow-lg border-0 rounded-lg mt-5">
                <div class="card-header badge-danger">
                  <p style="font-size:30px;font-weight:bold;">KRBS CIRCULARS</p>
                  <!--                  <p style="font-size:15px;">CREW LOGIN</p>-->
                  <span class="badge badge-pill badge-dark" v-show="isSelected=='crew'" @click="formAuthData.is_staff = false">CREW LOGIN</span>
                  <span class="badge badge-pill badge-warning" v-show="isSelected=='staff'" @click="formAuthData.is_staff = true">STAFF LOGIN</span>
                </div>

                <form @submit.prevent="logThisUser">
                  <div class="card-body">
                    <div class="form-group" v-if="formAuthData.is_staff">
                      <label class="small mb-1" for="username-staff">
                        <font-awesome-icon icon="user" />
                        USERNAME </label>
                      <input class="form-control py-2"
                             id="username-staff"
                             type="text"
                             placeholder="Enter Username"
                             v-model="formAuthData.username" />
                    </div>
                    <div class="form-group" v-else>
                      <label class="small mb-1" for="username-crew">
                        <font-awesome-icon icon="user" />
                        CREW IPN</label>
                      <input class="form-control py-2"
                             id="username-crew"
                             type="text"
                             placeholder="Enter Crew IPN"
                             v-model="formAuthData.username" />
                    </div>
                    <div class="form-group">
                      <label class="small mb-1" for="input-password">
                        <font-awesome-icon icon="lock" />
                        PASSWORD</label>
                      <div class="input-group">
                        <input class="form-control py-2"
                               id="input-password"
                               name="inputPassword"
                               type="password"
                               placeholder="Enter Password"
                               autocomplete="on"
                               v-model="formAuthData.password"
                               required
                        />
                        <div class="input-group-append">
                          <button class="btn btn-secondary" type="button" title="Show Password" @click="showPassword">
                            <font-awesome-icon :icon="this.icon" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="form-group" v-show="isSelected=='crew'">
                      <small class="text-right">
                        <strong>Note:</strong> Default password is numerical birth date format: "ddmmyyyy"
                      </small>
                      <br>
                      <small>
                        <strong>Ex:</strong> 18 December 1999 → <span style="color: red ">18121999</span>
                      </small>

                    </div>

                    <div class="form-group">
                      <button class="btn btn-outline-dark">
                        <font-awesome-icon v-if="!isLoading" icon="arrow-right-to-bracket" />
                        <font-awesome-icon v-if="isLoading" icon="spinner" spin />
                        Login
                      </button>
                    </div>
                  </div>

                </form>


              </div>
            </div>
          </div>
        </div>
      </main>
    </div>


    <base-app-footer></base-app-footer>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '@/mixins/app.mixins';
import axios from 'axios';

export default {
  name: 'Login',

  mixins: [AppMixins],

  data() {
    return {
      icon: 'eye-slash',
      isSelected: 'crew',
      // authentication: {
      //   username: 'elitesystemadmin',
      //   password: '$!3L!t3@2018$!$',
      //   is_staff: '',
      // },
      error: null,
      success: false,
    };
  },

  /** methods **/
  methods: {
    ...mapActions(
        [
          'loginUser',
        ],
    ),

    showPassword() {
      const input = document.getElementById('input-password');
      if (input.type == 'password') {
        input.type = 'text';
        this.icon = 'eye';

      } else {
        input.type = 'password';
        this.icon = 'eye-slash';
      }
    },

    // makeActive(val) {
    //   this.isSelected = val;
    // },

    isActiveTab(val) {
      this.formAuthData.is_staff = val !== 'crew';
      this.formAuthData.username='';
      this.formAuthData.password=''

      this.isSelected = val;
    },

    // login() {
    //   this.$router.push({name: 'Main'});
    // },

    // login() {
    //   axios.post(
    //       'http://localhost/krbs_api/public/api/memo_circular/login',
    //       {...this.authentication},
    //   ).then(res => {
    //     this.$router.push({name: 'Main'});
    //     console.log(res);
    //   }).catch(err => {
    //     console.log(err.response);
    //   });
    // },

    async logThisUser() {
      await this.loginUser(this.formAuthData).then((r) => {
        if (r) {
          this.$nextTick(() => {
            this.successFormAlert('Login Successfully');
            this.$router.push({name: 'Home'});
          });
        }
      });
    },

  },

  /** computed **/
computed: {
...mapGetters(
      [
        'formAuthData',
        'isLoading',
      ],
  ),
},
};



</script>

<style scoped>
.mt-0 {
  margin-top: 50px !important;
}

.nav-pills > li > a {
  color: #6c757d;
}

.nav-pills > li > a.active {
  background-color: #6c757d !important;
  color: white;
}

</style>
